exports.download = require('./lib/wget').download;
exports.request = require('./lib/wget').request;


//////////////////
// WEBPACK FOOTER
// ./~/wget-improved/index.js
// module id = 434
// module chunks = 0